import type { BannerProps } from './types.js'
import { cn } from '../../helpers/utils.js'
import { Picture, Text, Button } from '../../components/index.js'
import CountDown from '../CpnCountDown/index.js'

const CpnBanner = (props: BannerProps) => {
  const { id, image, imageMob, imageLink, content = [], cns } = props

  const btnClick = (target: string) => {
    if (target?.startsWith('http')) {
      location.href = target
    }
    if (target?.startsWith('#')) {
      const element = document.querySelector(target)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  return (
    <div id={id} className={cn('cpn-banner-container relative w-full', cns?.container)}>
      <Picture
        loading="eager"
        source={`${image}, ${imageMob || image} 768`}
        className={cn('cpn-banner-picture', cns?.picture)}
        imgClassName={cn('cpn-banner-image h-full object-cover', cns?.image)}
        alt=""
      />
      {imageLink && <a href={imageLink} className="absolute left-0 top-0 z-[1] size-full"></a>}
      <div
        className={cn(
          'cpn-banner-box tablet:flex tablet:flex-col tablet:justify-center tablet:pt-0 tablet:text-left absolute left-0 top-0 size-full pt-10 text-center',
          cns?.box
        )}
      >
        <div className={cn('cpn-banner-content-box tablet:px-10 desktop:px-20 px-6', cns?.contentBox)}>
          <div className={cn('cpn-banner-content tablet:mx-0 tablet:max-w-[40vw] mx-auto max-w-[70vw]', cns?.content)}>
            {content?.map((item, index) => {
              switch (item.type) {
                case 'subheading':
                  return (
                    <Text
                      key={index}
                      as="div"
                      html={item.text}
                      className={cn(
                        'cpn-banner-subheading tablet:text-[1.25vw] lg-desktop:text-[24px] mt-4 font-medium',
                        cns?.subheading
                      )}
                    />
                  )
                case 'title':
                  return (
                    <Text
                      key={index}
                      as="div"
                      html={item.text}
                      className={cn(
                        'cpn-banner-title tablet:mt-5 tablet:text-[2.7vw] lg-desktop:text-[56px] mt-4 text-[32px] font-bold leading-[1.12]',
                        cns?.title
                      )}
                    />
                  )
                case 'subtitle':
                  return (
                    <Text
                      key={index}
                      as="div"
                      html={item.text}
                      className={cn(
                        'cpn-banner-subtitle tablet:mt-5 tablet:text-[1.25vw] lg-desktop:text-[24px] mt-4 font-medium',
                        cns?.subtitle
                      )}
                    />
                  )
                case 'button':
                  return (
                    <div
                      className={cn(
                        'cpn-banner-buttonBox tablet:mt-6 tablet:justify-start mt-4 flex justify-center',
                        cns?.buttonBox
                      )}
                    >
                      <Button
                        key={index}
                        className={cn(
                          'cpn-banner-button tablet:min-w-[138px] tablet:px-7 lg-desktop:min-w-[156px] lg-desktop:px-8 !w-auto min-w-[120px] !max-w-full px-5',
                          cns?.button,
                          item.cns
                        )}
                        onClick={item.onClick ? item.onClick : () => btnClick(item.target || '')}
                      >
                        {item.text}
                      </Button>
                    </div>
                  )
                case 'buttons':
                  return (
                    <div
                      className={cn(
                        'cpn-banner-buttonBox tablet:mt-6 tablet:justify-start mt-4 flex justify-center',
                        cns?.buttonBox
                      )}
                    >
                      {item.buttons.map((button, index) => (
                        <Button
                          key={index}
                          className={cn(
                            'cpn-banner-button tablet:min-w-[138px] tablet:px-7 lg-desktop:min-w-[156px] lg-desktop:px-8 !w-auto min-w-[120px] !max-w-full px-5',
                            cns?.button,
                            button.cns
                          )}
                          onClick={button.onClick ? button.onClick : () => btnClick(button.target || '')}
                        >
                          {button.text}
                        </Button>
                      ))}
                    </div>
                  )
                case 'countdown':
                  return (
                    <div
                      key={index}
                      className="cpn-banner-countdown tablet:mt-6 tablet:justify-start mt-4 flex justify-center"
                    >
                      <CountDown endTime={item.endTime} copy={item.copy} cns={cns?.countdown} />
                    </div>
                  )
              }
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CpnBanner
